export default __webpack_public_path__ + "static/media/NEXUS.4466cf20.png";